import { COOKIE_CATEGORY } from 'common/constants/cookieManagement';

export const GOOGLE_ANALYTICS = 'googleAnalytics';
export const META_PIXEL = 'metaPixel';
export const LINKEDIN_INSIGHT = 'linkedInInsight';
export const MARKETO_MUNCHKIN = 'marketoMunchkin';
export const GOOGLE_TAG_MANAGER = 'googleTagManager';

export const PAGE_VIEW = 'pageView';
export const REGISTRATION_MODAL_OPEN = 'registrationModalOpen';
export const REGISTRATION_SUBMITTED = 'registrationSubmitted';

export const TRACKER_CATEGORIES = Object.freeze({
    [COOKIE_CATEGORY.PERFORMANCE]: [GOOGLE_ANALYTICS],
    [COOKIE_CATEGORY.FUNCTIONALITY]: [GOOGLE_TAG_MANAGER],
    [COOKIE_CATEGORY.MARKETING]: [META_PIXEL, LINKEDIN_INSIGHT, MARKETO_MUNCHKIN],
});
